import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {ModalBaseComponent} from 'web-common/src/app/modals/modal-factory/modal-base/modal-base.component';
import {AdminAvailableModals} from '../admin-available-modals';
import {User} from 'web-common/src/app/user/user';


@Component({
    selector: 'app-confirm-deactivate-user',
    templateUrl: './confirm-deactivate-user.component.html',
    standalone: false
})
export class ConfirmDeactivateUserComponent extends ModalBaseComponent<any> implements AfterViewInit {

  @ViewChild('confirmDeactivateUser', { static: true }) public modalView: ModalDirective;

  ngAfterViewInit() {
    this.modalId = AdminAvailableModals.CONFIRM_DISABLE_USER;
    this.modalView.show();
  }

  public returnType(obj) {
    return typeof obj;
  }

}
